import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'vi', // set locale    
  fallbackLocale: 'vi', // set fallback locale    
  messages: {
    vi: require('@/assets/i18n/vi.json'),
    en: require('@/assets/i18n/en.json')
  }
});

export default i18n